const state = {
    editableTabs: [], // all tabs
    selectTabName: "",
    currentWidth: "",
    isSideShow: true,
    isHeadShow:true
}

const mutations = {
    ADD_TAB: (state, menuItem) => {
        let ishastab = state.editableTabs.some(function (item) {
            return item.name === menuItem.path;
        });
        if (!ishastab) {
            state.editableTabs.push({
                title: menuItem.title,
                icon: menuItem.icon,
                name: menuItem.path,
                component: menuItem.component,
                params: menuItem.params
            });
        }
        state.selectTabName = menuItem.path;
    },
    REMOVE_TAB: (state, targetName) => {
        let tabs = state.editableTabs;
        let activeName = state.selectTabName;
        if (activeName === targetName) {
            tabs.forEach((tab, index) => {
                if (tab.name === targetName) {
                    let nextTab = tabs[index + 1] || tabs[index - 1];
                    if (nextTab) {
                        activeName = nextTab.name;
                    }
                }
            });
            state.selectTabName = activeName;
        }
        state.editableTabs = tabs.filter(tab => tab.name !== targetName);
    },
    CLEAR_TABS: (state) => {
        state.editableTabs = [];
        state.selectTabName = "";
    },
    SET_SELECTTABNAME: (state, newvalue) => {
        state.selectTabName = newvalue;
    },
    SET_CURRENTWIDTH: (state, newvalue) => {
        state.currentWidth = newvalue;
    },
    SET_SIDESHOW: (state, newvalue) => {
        state.isSideShow = newvalue;
    },
    SET_HEADSHOW: (state, newvalue) => {
        state.isHeadShow = newvalue;
    }
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
